import { useMutation } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

export interface FeedbackMessageCreateRequestData {
	feedbackId: string;
	text: string;
	publish: boolean;
}

export const useSendMessage = (options = {}) => {
	const http = useHttpClient('v2');
	const feedbackMessageMutation = useMutation((data: FeedbackMessageCreateRequestData) => {
		return http.post(`/constructive_feedback/feedback_messages/`, {
			message: {
				feedback_id: data.feedbackId,
				text: data.text,
				publish: data.publish,
			},
		});
	}, options);

	return feedbackMessageMutation;
};
